import "./App.css";
import Faq from "./views/Faq";
import Gallery from "./views/Gallery";
import Camp from "./views/Camp";
import Home from "./views/Home";
import Navigation from "./components/modules/Navigation";
import Footer from "./components/modules/Footer";
import Franchise from './views/Franchise';
import { Routes, Route, Navigate } from "react-router-dom";
import ContactUs from "./views/ContactUs";

import Whatsapp from "./components/modules/Whatsapp";
import Cookies from "./components/modules/Cookies";
import PrivacyPolicy from "./views/PrivacyPolicy";
import AboutUs from "./views/AboutUs";

const App = () => {
  return (
    <div>
      <Navigation />
      <Routes>
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/kotecafe" element={<Camp />} />
        <Route path="/idlydosacamp" element={<Navigate to="/kotecafe" replace />} />
        <Route path="/franchise" element={<Franchise />} />
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>
      <Whatsapp />
      <Cookies />
      <Footer />
    </div>
  );
};

export default App;
